var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2519_43489)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5C10.4602 2.5 10.8333 2.8731 10.8333 3.33333V16.6667C10.8333 17.1269 10.4602 17.5 10 17.5C9.53976 17.5 9.16667 17.1269 9.16667 16.6667V3.33333C9.16667 2.8731 9.53976 2.5 10 2.5ZM6.66667 5C7.1269 5 7.5 5.3731 7.5 5.83333V14.1667C7.5 14.6269 7.1269 15 6.66667 15C6.20643 15 5.83333 14.6269 5.83333 14.1667V5.83333C5.83333 5.3731 6.20643 5 6.66667 5ZM13.3333 5C13.7936 5 14.1667 5.3731 14.1667 5.83333V14.1667C14.1667 14.6269 13.7936 15 13.3333 15C12.8731 15 12.5 14.6269 12.5 14.1667V5.83333C12.5 5.3731 12.8731 5 13.3333 5ZM3.33333 7.5C3.79357 7.5 4.16667 7.8731 4.16667 8.33333V11.6667C4.16667 12.1269 3.79357 12.5 3.33333 12.5C2.8731 12.5 2.5 12.1269 2.5 11.6667V8.33333C2.5 7.8731 2.8731 7.5 3.33333 7.5ZM16.6667 7.5C17.1269 7.5 17.5 7.8731 17.5 8.33333V11.6667C17.5 12.1269 17.1269 12.5 16.6667 12.5C16.2064 12.5 15.8333 12.1269 15.8333 11.6667V8.33333C15.8333 7.8731 16.2064 7.5 16.6667 7.5Z",
    fill: "#00FF97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2519_43489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleplay);
export default __webpack_public_path__ + "static/media/roleplay.1067851f5a79a671714cf9337f491c9e.svg";
export { ForwardRef as ReactComponent };